import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/hooks/useAuth'
import { trackMarketing } from '@/modules/marketingAnalytics'
import { HomePageFooterNote } from './HomePageFooterNote'
import { HomePageFoundations } from './HomePageFoundations'
import { HomePageGoDeeper } from './HomePageGoDeeper'
import { HomePageHero } from './HomePageHero'
import { HomePageManifestoTeaser } from './HomePageManifestoTeaser'
import { HomePageTestimonials } from './HomePageTestimonials'
import { HomePageVoiceCard } from './HomePageVoiceCard'

export const HomePage = () => {
  const { isAuthenticated, openLoginDialog, openSignupDialog } = useAuth()
  const navigate = useNavigate()

  const handlePrimaryCta = () => {
    if (isAuthenticated) {
      trackMarketing('home:hero:primary_cta_click', { variant: 'try_challenge' })
      navigate({ to: '/challenges/available' })
    } else {
      trackMarketing('home:hero:primary_cta_click', { variant: 'signup' })
      openSignupDialog()
    }
  }

  const handleLoginCta = () => {
    trackMarketing('home:hero:login_cta_click')
    openLoginDialog()
  }

  return (
    <div className="flex flex-1 w-full justify-center">
      <div className="flex-1 min-w-0 max-w-6xl space-y-10 md:space-y-12 mt-4 md:mt-8">
        <HomePageHero
          isAuthenticated={isAuthenticated}
          onPrimaryCta={handlePrimaryCta}
          onLoginCta={handleLoginCta}
        />

        {isAuthenticated && <HomePageVoiceCard />}

        <HomePageFoundations />

        <div aria-hidden className="h-px bg-border/50" />

        <HomePageGoDeeper />

        <div aria-hidden className="h-px bg-border/50" />

        <HomePageTestimonials />

        <div aria-hidden className="h-px bg-border/50" />

        <HomePageManifestoTeaser />

        <HomePageFooterNote />
      </div>
    </div>
  )
}
